<xds-dialog-shell
  titleKey="COMPANY_SELECTION_TITLE"
  icon="fa-light fa-building"
  (closed)="cancel()"
>
  <p class="dialog-subtitle">{{ 'COMPANY_SELECTION_SUBTITLE' | translate }}</p>

  <!-- Company List -->
  <div class="company-list">
    <div
      *ngFor="let company of data.companies"
      class="company-card"
      [class.selected]="selectedCompanyId === company.CompanyId"
      [class.default]="company.IsDefault"
      (click)="selectCompany(company.CompanyId)"
    >
      <!-- Company Icon -->
      <div class="company-icon">
        <img
          *ngIf="company.CompanyIcon"
          [src]="company.CompanyIcon"
          [alt]="company.CompanyName"
          class="company-logo"
        />
        <div *ngIf="!company.CompanyIcon" class="company-icon-placeholder">
          <i class="fa-light fa-building"></i>
        </div>
      </div>

      <!-- Company Info -->
      <div class="company-info">
        <h3 class="company-name">{{ company.CompanyName }}</h3>
        <div class="company-role">
          <i class="fa-light" [ngClass]="getRoleIcon(company.Role)"></i>
          <span>{{ getRoleLabel(company.Role) }}</span>
        </div>
      </div>

      <!-- Selection Indicator -->
      <div class="selection-indicator">
        <i
          class="fa-solid"
          [class.fa-circle-check]="selectedCompanyId === company.CompanyId"
          [class.fa-circle]="selectedCompanyId !== company.CompanyId"
        ></i>
      </div>

      <!-- TODO xds-migrate: positionierte Ecken-Ribbon (absolute, Karten-Ecke, uppercase) statt
           Inline-Pill; xds-badge würde die Ribbon-Optik verlieren (gleiche Begründung wie
           settings/subscription-settings .plan-badge / plan-selection-dialog .option-badge). -->
      <div class="default-badge" *ngIf="company.IsDefault">
        <i class="fa-light fa-star"></i>
        <span>{{ 'DEFAULT' | translate }}</span>
      </div>
    </div>
  </div>

  <!-- Actions -->
  <div xdsDialogFooter>
    <xds-button
      variant="secondary"
      (clicked)="cancel()"
      [disabled]="isLoading"
    >
      {{ 'CANCEL' | translate }}
    </xds-button>
    <xds-button
      variant="primary"
      iconLeft="fa-light fa-arrow-right"
      [loading]="isLoading"
      (clicked)="confirmSelection()"
      [disabled]="!selectedCompanyId || isLoading"
    >
      {{ 'CONTINUE' | translate }}
    </xds-button>
  </div>
</xds-dialog-shell>
